import {
    CREATE_TEMP_VIDEO,
    DELETE_VIDEO
  } from '../actions'
  
  const initialState = {
    tempcode: null
  }
  
  export default function tools(state = initialState, action) {
    switch (action.type) {
      case CREATE_TEMP_VIDEO:
        return {
          ...state,
          tempcode: action.payload
        }
      case DELETE_VIDEO:
        return {
          ...state,
          tempcode: action.payload.shortcode == state.tempcode ? null : state.tempcode
        }
      default:
        return state
    }
  }
    